export const formatWithThousandsSeparator = (number: any) => {
    if (number === undefined || number === null) {
        return 'Invalid number';
    }
    if (typeof number !== 'number') {
        number = parseFloat(number);
        if (isNaN(number)) {
            return 'Invalid number';
        }
    }
    return number.toLocaleString('fr-FR');
};

export const formatAmount = (amount: number) => {
    const [integerPart, decimalPart] = String(amount).split('.');
    const formattedIntegerPart = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        '.',
    );
    const formattedAmount = decimalPart
        ? `${formattedIntegerPart}.${decimalPart}`
        : formattedIntegerPart;
    return formattedAmount;
};
